<div class="map" id="map-{{index}}">
</div>